// extracted by mini-css-extract-plugin
export default {"heading":"homeHeading_heading__X6VeX"};